import apis from "@/apis";
import { update } from "../../utils";

const api = apis.accounts.paper;
const defaultBetOptions = [
  {
    langKey: "enum.betOptions[0]",
    value: 0,
  },
  // 實際流水
  {
    langKey: "enum.betOptions[1]",
    value: 1,
  },
  // 體驗金
  {
    langKey: "enum.betOptions[2]",
    value: 2,
  },
];

export default {
  namespaced: true,
  state: {
    searchData: {
      // 注單篩選
      betOption: 0,
      // 查詢帳號
      targetName: "",
      // 三方篩選
      third_party: [],
      // 帳號篩選
      users: ""
    },
    // AJAX 回應-Table未改先不放這邊
    response: {},
    // 非明細层的欄位設定
    normalColumns: [],
    // 總計列的欄位設定
    amountColumns: [],
    // 明細层的欄位設定
    detailColumns: [],
    // 明細层的總計列欄位設定
    detailAmountColumns: [],
    // 注單篩選項目
    betFilters: defaultBetOptions,
    clickedUser: null,
    thirdPartyData: [],
  },
  actions: {
    fetchColumns(context) {
      return api.getColumns().then(response => {
        context.commit('update', {
          normalColumns: response.data.columns,
          detailColumns: response.data.detailColumns,
          amountColumns: response.data.columns.filter((c) => {
            return 'amount_bar' in c && c.amount_bar;
          }),
          detailAmountColumns: response.data.detailColumns.filter((c) => {
            return 'amount_bar' in c && c.amount_bar;
          }),
        });
        context.commit('update_betFilter', response.data.betFilters);
        return Promise.resolve(response);
      });
    }
  },
  mutations: {
    update,
    update_betFilter(state, data) {
      data.forEach(item => {
        let index = state.betFilters.findIndex(x => x.langKey == item.langKey);
        if (-1 == index) {
          state.betFilters.push(item);
        }
      });
    },
    update_search(state, data) {
      for (let key in state.searchData) {
        if (key in data) {
          state.searchData[key] = data[key];
        }
      }
    }
  }
}